import { useEffect } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { useCourse } from "../contexts/CourseContext";
import { FaChevronDown } from "react-icons/fa";
import '../styles/components/ui/course-selector.css';

export default function CourseSelector() {
  const { selectedCourse, selectCourse, courses } = useCourse();
  
  console.log("CourseSelector - selectedCourse:", selectedCourse);
  console.log("CourseSelector - courses:", courses);
  
  // Auto-select first course if none is selected
  useEffect(() => {
    if (courses && courses.length > 0 && !selectedCourse) {
      const firstCourse = courses[0];
      selectCourse(firstCourse);
      localStorage.setItem("selectedCourse", JSON.stringify(firstCourse));
    }
  }, [courses, selectedCourse, selectCourse]);
  
  const handleSelect = (crn) => {
    console.log("CourseSelector - handleSelect called with CRN:", crn);
    const courseObj = courses.find(c => String(c.CRN) === String(crn));
    console.log("CourseSelector - Found course object:", courseObj);
    if (courseObj) {
      selectCourse(courseObj);
      localStorage.setItem("selectedCourse", JSON.stringify(courseObj));
      console.log("CourseSelector - Course selected successfully");
    }
  };

  // Only show course selector if user is enrolled in multiple courses
  if (!courses || courses.length <= 1) return null;

  return (
    <Dropdown onSelect={handleSelect} className="course-selector-dropdown">
      <Dropdown.Toggle
        variant="secondary"
        id="course-dropdown"
        className="course-selector-toggle"
      >
        {selectedCourse?.name || "Select your course"}{selectedCourse?.semester ? ` - ${selectedCourse.semester}` : ''}
        <FaChevronDown className="course-selector-chevron" />
      </Dropdown.Toggle>
      <Dropdown.Menu className="course-selector-menu">
        {courses.map((course, index) => (
          <Dropdown.Item
            key={course.CRN || course.name || `course-${index}`}
            eventKey={course.CRN}
            active={selectedCourse?.CRN === course.CRN}
            className="course-selector-item"
          >
            {course.name || course.title || course}{course.semester ? ` - ${course.semester}` : ''}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}